import React from 'react';
import { Fab } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/styles';
import { useFirebase } from 'components/Firebase/context';

const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  icon: {
    margin: spacing(1)
  },
  facebook: {
    color: palette.getContrastText('#3C5A99'),
    '&:hover': {
      backgroundColor: '#2a3e6b'
    },
    backgroundColor: '#3C5A99'
  },
  google: {
    color: palette.getContrastText('#992f26'),
    backgroundColor: '#DB4437',
    '&:hover': {
      backgroundColor: '#992f26'
    }
  }
}));
const SocialMediaLogin = () => {
  const firebase = useFirebase();
  const classes = useStyles({})
;
  const signInWithGoogle = () => {
    return isMobile ? firebase.doGoogleSignInRedirect() : firebase.doGoogleSignInPopup();
  };

  const signInWithFacebook = () => {
    return isMobile ? firebase.doFacebookSignInRedirect() : firebase.doFacebookSignInPopup();
  };
  return (
    <div className={classes.root}>
      <Fab className={classNames(classes.icon, classes.google)} aria-label="Google" onClick={() => signInWithGoogle()}>
        <FontAwesomeIcon icon={['fab', 'google']} />
      </Fab>
      <Fab
        className={classNames(classes.icon, classes.facebook)}
        aria-label="Facebook"
        onClick={() => signInWithFacebook()}
      >
        <FontAwesomeIcon icon={['fab', 'facebook-f']} />
      </Fab>
    </div>
  );
};

export default SocialMediaLogin;
